import React from 'react'


const KuwaitFlag = () => {
  return (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_479_21873)">
<g clipPath="url(#clip1_479_21873)">
<path fillRule="evenodd" clipRule="evenodd" d="M0 7.5H20V12.5009H0V7.5Z" fill="#F7F9FA"/>
<path fillRule="evenodd" clipRule="evenodd" d="M0 12.5H20V17.501H0V12.5Z" fill="#F50500"/>
<path fillRule="evenodd" clipRule="evenodd" d="M0 2.5H20V7.50098H0V2.5Z" fill="#00AC00"/>
<path fillRule="evenodd" clipRule="evenodd" d="M0 2.5V17.5L7.48243 12.499L7.5 7.49512L0 2.5Z" fill="black"/>
</g>
</g>
<defs>
<clipPath id="clip0_479_21873">
<rect width="20" height="20" fill="white"/>
</clipPath>
<clipPath id="clip1_479_21873">
<rect width="20" height="20" fill="white"/>
</clipPath>
</defs>
</svg>

  )
}

export default KuwaitFlag


